import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { useApiStore } from './stores/apiStore'
//import * as Sentry from "@sentry/vue";
import packageInfo from '../package.json'

import App from './App.vue'
import router from './router'
import VueSignaturePad from 'vue-signature-pad';

/* Sentry.init({
    dsn: "https://7c5c07303d238c136036a738f6affe94@o4504131042672640.ingest.sentry.io/4506468666048512",
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
      }),
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
   */

// Version check logic
const checkAppVersion = () => {
  const storedUser = localStorage.getItem('user')
  if (!storedUser) return // No user logged in, nothing to check
  
  const storedVersion = localStorage.getItem('appVersion')
  
  // Handle legacy users (no version stored)
  if (!storedVersion) {
    console.log('No version info found. Forcing re-login for legacy user.')
    localStorage.removeItem('user')
    // Store current version to prevent future forced logouts
    localStorage.setItem('appVersion', packageInfo.version)
    // Force reload to ensure clean app state and redirect to login
    location.reload()
    return
  }
  
  const currentVersion = packageInfo.version
  
  // Parse versions to compare
  const storedParts = storedVersion.split('.')
  const currentParts = currentVersion.split('.')
  
  // If major or minor version changed (first or second number), force logout
  if (storedParts[0] !== currentParts[0] || storedParts[1] !== currentParts[1]) {
    console.log('Major or minor version change detected. Forcing re-login.')
    localStorage.removeItem('user')
    localStorage.removeItem('appVersion')
    // Force reload to ensure clean app state and redirect to login
    location.reload()
  }
  // For patch version changes (third number), we keep the user logged in
}

// Run version check on app startup
checkAppVersion()

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(VueSignaturePad);

app.mount('#app')

// Access the Pinia store after the app is mounted
const apiStore = useApiStore()

if(navigator.onLine) {
    apiStore.connected();
} else {
    apiStore.disconnected();
}
    
//console.log('online', navigator.onLine);

window.addEventListener('offline', function () {
    apiStore.disconnected();
})

window.addEventListener('online', function () {
    apiStore.connected();
})
